import {
    PAYEE_USER_ERROR,
    PAYEE_USER_START,
    PAYEE_USER_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.payee, action = {type: ''}) => {
    switch (action.type) {
        case PAYEE_USER_START:
            return {
                error: false,
                loading: true,
                success: false,
            };
        case PAYEE_USER_SUCCESS:
            return {
                error: false,
                loading: false,
                success: true,
            };
        case PAYEE_USER_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/payeeUserReducer.js